import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { ContractStatus } from '../../../../../core';

@JsonConverter
export class ContractStatusAdapter implements JsonCustomConvert<ContractStatus | undefined> {
    serialize(status: ContractStatus): any | undefined {
        return status ? String(status) : undefined;
    }

    deserialize(status: any): ContractStatus | undefined {
        switch (status) {
            case 'CREATED':
                return ContractStatus.CREATED;
            case 'FINALIZED':
                return ContractStatus.FINISHED;
            case 'FOR SIGNING':
                return ContractStatus.FOR_SIGN;
            case 'PRODUCTIVE':
                return ContractStatus.PRODUCTIVE;
            case 'REJECTED':
                return ContractStatus.REJECTED;
            case 'SENT':
                return ContractStatus.SENT;
            case 'CANCELED':
                return ContractStatus.CANCELED;
            case 'PBC_REVIEW':
                return ContractStatus.PBC_REVIEW;
            default:
                return ContractStatus.OTHER;
        }
    }
}
